export * from './types';
export * from './createAlgoliaInsightsPlugin';


//////////////////
// WEBPACK FOOTER
// /home/runner/work/medischeartikelen-website/medischeartikelen-website/node_modules/@algolia/autocomplete-plugin-algolia-insights/dist/esm/index.js
// module id = 53
// module chunks = 0